import { render, staticRenderFns } from "./OrganizationOffer.vue?vue&type=template&id=603c29a2&"
import script from "./OrganizationOffer.vue?vue&type=script&lang=js&"
export * from "./OrganizationOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports